module.exports = __webpack_public_path__ + "static/media/inventory.63975e59.png";